export const getCompaniesModuleOptions = (data: { [key: number]: string }) => {
    if (!data) return [];
    const modulesOptions = Object.entries(data);

    return modulesOptions.map(item => ({
        id: parseInt(item[0], 10),
        name: item[1],
        display_name: item[1],
    }));
};
